import React from 'react';

import CompanyList from './CompanyList';

import classes from './CompanyManagement.module.css';

const TableContainer = ({
    companyCreate,
    setCompanyCreate,
    setSelectedCompany,
    ...props
}) => {

    return (
        <div className={classes.TableContainer}>
            <div className={classes.GridContainer}>
                <CompanyList 
                    companyCreate={companyCreate}
                    setCompanyCreate={setCompanyCreate}
                    setSelectedCompany={setSelectedCompany}
                />
            </div>
        </div>
    );
};

export default TableContainer;
